import React from "react";
import "./index.scss";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
} from "../common_widgets/popup";
import MdaeButton from "../common_widgets/button";
import { formatManualCaseObjectBeforeSave, SET_IS_SAVE_FROM_VALIDATION_FOR_MANUAL_EXPEDITE_CASE_SEARCH, TOGGLE_VALIDATION_SUMMARY_POPUP } from "./reducer/add-case-manual-reducer";
import { useDispatch, useSelector } from "react-redux";
import { isEqual, last } from "lodash";
import { ADD_MANUAL_CASE_POPUP_MODES, insertManualCase, updateManualCase, caseDetailValidationGroup, setManualCaseSaveButtonDisabledProperty, onAddExpediteManualCasesToAuditBtnClick } from "./component";
import { SHOW_LOADER } from "../mdae-common-reducer";
import { ValidationSummary } from "devextreme-react";
import { actions as asyncActions } from "async-ops";


interface IShowValidationSummary {
  refreshCasesList: () => void; 
}
export interface ICodeValidationSummaryObject {
    codeLookupValidationMessageButtonTitle: string;
    showCodeValidationSummary: boolean;
    lookUpValidationMessage: any[];
  };

export const toggleValidationSummaryPopup = (
  dispatch,
  isVisible,
  data:ICodeValidationSummaryObject = null,
  title = "Code Lookup Validation",
) => {
  dispatch({
    type: TOGGLE_VALIDATION_SUMMARY_POPUP,
    data: {
      isValidationSummaryPopupVisible: isVisible,
      validationSummaryPopupTitle: title,
      validationSummaryPopupData: data,
    },
  });
  setManualCaseSaveButtonDisabledProperty(dispatch, isVisible);
};
export const saveManualCaseFromValidation = (
  dispatch,
  addCaseManualPopupMode,
  addCaseManualFormData,
  eaAuditId,
  eaRoundId,
  refreshCasesList: () => void,
  auditPropertiesData,
  addCaseToRoundNumber,
  caseDataTabData
) => {
  toggleValidationSummaryPopup(dispatch, false);
  dispatch({ type: SHOW_LOADER });
  if (addCaseManualPopupMode === ADD_MANUAL_CASE_POPUP_MODES.CREATE) {
    const addCaseManualFormDataToSave = formatManualCaseObjectBeforeSave(
      addCaseManualFormData,
      eaAuditId,
      eaRoundId,
      addCaseToRoundNumber,
      null
    );
    insertManualCase(dispatch, addCaseManualFormDataToSave, 0, refreshCasesList,   auditPropertiesData,
  addCaseManualFormData,caseDataTabData);
  } else {
    const addCaseManualFormDataToSave = formatManualCaseObjectBeforeSave(
      addCaseManualFormData,
      eaAuditId,
      eaRoundId,
      addCaseToRoundNumber,
      null,
      true
    );
    updateManualCase(dispatch, addCaseManualFormDataToSave, false, refreshCasesList);
  }
};

const ShowValidationSummary: React.FC<IShowValidationSummary> = (props) => {
  const dispatch = useDispatch();
  const addCaseManualFormData = useSelector(
    (state) => state["addCaseManualReducer"].addCaseManualFormData,
    isEqual
  );
  const firstEaRound = useSelector(
    (state) => last(state["externalAuditReducer"].eaAuditRounds),
    isEqual
  );
  const eaAuditId = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData?.eaAuditId,
    isEqual
  );
  const addCaseManualPopupMode = useSelector(
    (state) => state["addCaseManualReducer"].addCaseManualPopupMode,
    isEqual
  );
  const validationSummaryPopupData:ICodeValidationSummaryObject = useSelector(
    (state) => state["addCaseManualReducer"].validationSummaryPopupData,
    isEqual
  );
  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );
   const claimTypes = useSelector(
     (state) => state["addCaseManualReducer"].claimTypes
   );
   const currentUser = useSelector(
     (state) => state["mdaeNavigationBarReducer"].currentUser
   );
   const saveManualCaseDataParams = useSelector(
     (state) => state["addCaseManualReducer"].saveManualCaseDataParams
   );
   const isManualExpediteCaseSearch = useSelector(
     (state) => state["addCaseManualReducer"].isManualExpediteCaseSearch
   );
    const addCaseToRoundNumber = useSelector(
      (state) => state["externalAuditReducer"].addCaseToRoundNumber
    );
   const caseDataTabData = useSelector(
        (state) => state["caseDataReducer"].caseData
      );
  const getValidationSummaryPopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          toggleValidationSummaryPopup(dispatch, false);
        }}
      ></MdaePopupTitle>
    );
  };
  return (
    <div>
      <MdaePopup
        deferRendering={false}
        width={600}
        height={410}
        className="validation-summary-popup"
        mdaeTitleRender={getValidationSummaryPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_VALIDATION_SUMMARY_POPUP,
            reducerName: "addCaseManualReducer",
            widgetOptionBindings: {
              visible: "isValidationSummaryPopupVisible",
              mdaePopupTitle: "validationSummaryPopupTitle",
            },
          },
        ]}
        mdaeContentRender={() => (
          <MdaePopupContent>
            <div className="row validation-summary-popup-content">
              <div className="col-lg-12 margin-lg-top margin-lg-bottom">
                <div className="row" style={{ paddingLeft: 25 }}>
                  {validationSummaryPopupData?.lookUpValidationMessage?.length > 0 ? (
                    <table style={{ width: 570 }}>
                      {validationSummaryPopupData?.lookUpValidationMessage?.map(
                        (item) => (
                          <tr>
                            <td className="text-danger">{item?.code}</td>
                          </tr>
                        )
                      )}
                    </table>
                  ) : (
                    <div>
                      <ValidationSummary validationGroup={caseDetailValidationGroup} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </MdaePopupContent>
        )}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"btnSaveAndCloseAddCaseManualPopup"}
                  role={"primary"}
                  onClick={() => {
                    if (
                      validationSummaryPopupData?.codeLookupValidationMessageButtonTitle?.toLocaleLowerCase() ===
                      "save"
                    ) {
                      if (isManualExpediteCaseSearch === true) {
                        dispatch({
                          type: SET_IS_SAVE_FROM_VALIDATION_FOR_MANUAL_EXPEDITE_CASE_SEARCH,
                          data: {
                            isSaveFromValidationForManualExpediteCaseSearch: true,
                          },
                        });
                        onAddExpediteManualCasesToAuditBtnClick(
                          dispatch,
                          asyncActions,
                          addCaseManualFormData,
                          claimTypes,
                          currentUser,
                          { location: saveManualCaseDataParams.location }
                        );
                      } else {
                        saveManualCaseFromValidation(
                          dispatch,
                          addCaseManualPopupMode,
                          addCaseManualFormData,
                          eaAuditId,
                          firstEaRound?.eaRoundId,
                          props.refreshCasesList,
                          auditPropertiesData,
                          addCaseToRoundNumber,
                          caseDataTabData
                        );
                      }
                    } else toggleValidationSummaryPopup(dispatch, false);
                  }}
                >
                  {validationSummaryPopupData?.codeLookupValidationMessageButtonTitle ||
                    "Save"}
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      />
    </div>
  );
};

export default ShowValidationSummary;
